module.exports = __webpack_public_path__ + "static/toyota-64689a37c5ec5df29f8626359ed53b63.png";